import { render, staticRenderFns } from "./dutyfree.vue?vue&type=template&id=04cf9fd8&"
import script from "./dutyfree.vue?vue&type=script&lang=js&"
export * from "./dutyfree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports